import { CContainer, CHeader, CHeaderNav, CNavLink, CNavItem, CNav } from '@coreui/react';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { generatePath as generatePathRouter } from 'react-router';
import { NavLink, useNavigate } from 'react-router-dom';

import logo from '../../assetsOld/logo/erikLogo100x200.png';
import { RootState } from '../../reducers';
import { generateUrl, RouteRule } from '../../routes/RouteManager';
import types from '../../types/actions';
import navigation from './navigation';

const AppHeader = () => {
	const headerRef = useRef(null);
	const navigate = useNavigate();

	const dispatch = useDispatch();
	const sidebarShow = useSelector((state: RootState) => state.layout.sidebarShow);

	const handleSidebar = useCallback(() => {
		dispatch({
			type: types.SET_LAYOUT_SIDEBAR,
			payload: { sidebarShow: !sidebarShow },
		});
	}, [dispatch]);

	useEffect(() => {
		document.addEventListener('scroll', () => {
			// eslint-disable-next-line @typescript-eslint/no-unused-expressions
			headerRef.current &&
				// @ts-ignore
				headerRef.current.classList.toggle('shadow-sm', document.documentElement.scrollTop > 0);
		});
	}, []);

	return (
		<CHeader className='p-0' position='sticky' ref={headerRef}>
			<CContainer className='border-bottom px-4' fluid style={{ minHeight: '100px' }}>
				<CHeaderNav className='d-flex'>
					<CNav className='d-flex align-items-center justify-content-center' style={{ fontSize: 'larger' }}>
						<CNavItem>
							<a href={generateUrl(RouteRule.home)}>
								<img alt='erik.sk' height={50} src={logo} style={{ cursor: 'pointer' }} />
							</a>
						</CNavItem>
						<div className='d-none d-md-flex'>
							{navigation.map((item) => {
								return (
									<CNavItem key={item.name}>
										<CNavLink as={NavLink} onClick={() => navigate(generatePathRouter(item.to))} to={item.to}>
											{item.name}
										</CNavLink>
									</CNavItem>
								);
							})}
						</div>
					</CNav>
				</CHeaderNav>
				<CHeaderNav className='ms-auto d-flex d-md-none'>
					<CNavItem>
						<CNavLink href='#' onClick={handleSidebar}>
							<FontAwesomeIcon icon={faBars} size='2xl' />
						</CNavLink>
					</CNavItem>
				</CHeaderNav>
			</CContainer>
		</CHeader>
	);
};

export default AppHeader;
